import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../utils/Api";
import StaticFunctions from "../utils/StaticFunctions";

import './LoginPage.css';

class LoginPage extends Component {

    static propTypes = {
        languages: PropTypes.array.isRequired,
        translate: PropTypes.func.isRequired,
        zskLinks: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired,
        setUrlStateParams: PropTypes.func.isRequired,
        onLoggedInChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        mail: ''
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        let initMail = (props.mail && StaticFunctions.validateEmail(props.mail)) ? props.mail.replace(/<[^>]*>?/gm, '') : '';

        this.state = {
            inputParams: {
                focus: (initMail) ? 'loginPassword' : 'loginEMail',
                loginEMail: initMail,
                loginPassword: '',
            }
        };

        this.focusPassword = this.focusPassword.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);

        this.translate = this.props.translate;
        this.selectedLanguage = props.i18n.language;

        this.handleEMail = this.handleEMail.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.getLanguageOptions = this.getLanguageOptions.bind(this);

    }

    componentWillMount() {

        //this.loginEMail.focus();

    }

    handleRequest() {

        const email = this.state.inputParams.loginEMail;
        const pw = this.state.inputParams.loginPassword;

        if (StaticFunctions.validateEmail(email)) {
            const params = {
                email: this.state.inputParams.loginEMail,
                password: this.state.inputParams.loginPassword
            };

            const callback = function (res) {
                if (res && res.login_success && res.login_success === true) {
                    this.props.onLoggedInChange(true);
                } else {
                    this.props.onLoggedInChange(false);

                    alert(this.translate(res.msg));
                }
            }.bind(this);

            this.api.request('Auth', params, callback, null);
        }

    }

    handleForgotPassword() {

        const email = this.state.inputParams.loginEMail;

        if (StaticFunctions.validateEmail(email)) {
            const params = {
                action: 'requestPassword',
                email: email
            };

            const callback = function (res) {
                if (res) {
                    alert(this.translate('passwordMailWasSent'));
                } else {
                    alert(this.translate('authentificationFailed'));
                }
            }.bind(this);

            this.api.request('RequestForgotPassword', params, callback, null);
        } else {
            alert(this.translate('passwordForgotText1') + '\n' + this.translate('passwordForgotText2'));
        }

    }

    handleUrlStateParams(params) {

        this.props.setUrlStateParams(params);

    }

    handleRegister() {

        this.props.setUrlStateParams({show: 'register'});

    }

    handleEMail(event) {

        if (!event) return null;

        this.handleInput('loginEMail', event.target.value);

    }

    handlePassword(event) {

        if (!event) return null;

        this.handleInput('loginPassword', event.target.value);

    }

    handleInput(fieldName, value) {

        if (!fieldName) return null;

        const inputParams = {...this.state.inputParams};

        inputParams[fieldName] = value;

        this.setState({inputParams});

    }

    focusPassword(event) {

        if (event.key === "Enter" && this.passwordInput) this.passwordInput.focus();

    }

    handleKeyPress(event) {

        if (event.key === "Enter") this.handleRequest();

    }

    changeLanguage(event) {

        if (event) {
            const selectedLanguage = event.target.value;

            this.selectedLanguage = selectedLanguage;
            this.props.i18n.changeLanguage(selectedLanguage);
        }

    }

    getLanguageOptions() {

        const languages = this.props.languages;

        return languages.map(
            (language, index) => {
                return (
                    <option key={'option-' + index} value={language.value}>{language.label}</option>
                );
            }
        );

    }

    render() {

        const options = this.getLanguageOptions();
        const zskUrl = this.props.zskLinks.homePage;
        const zskHomePage = zskUrl + ((this.selectedLanguage === 'de') ? '/de' : '/en') ;
        const zskImprintLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.imprint;
        const zskPolicyLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.policy;
        const zskConditionLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.condition;
        const zskContactLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.contact;

        //const linkToDownload = (this.selectedLanguage === 'de') ? 'https://www.zsk.de/de/software/my-zsk.php' : 'https://www.zsk.de/en/software/my-zsk.php';
        const linkToDownload = 'https://shop.zsk.de/product/datacollector-software/';

        return (
            <div>
                {/*<h1></h1>*/}
                <div id="pwdreq" className="pwdbox">
                    <div className="pwdclose">x</div>

                    <div className="pwdcontainer">
                        <div className="pwdforms">
                            <h1>{this.translate('passwordForgotten')}</h1>

                            <p>{this.translate('passwordForgotText1')}</p>
                            <p>{this.translate('passwordForgotText2')}</p>

                            <form method="post" action="return false;">
                                <div className="input">
                                    <input id="passwordForgotMail" className="input__field" type="text"/>

                                    <label className="input__label" htmlFor="passwordForgotMail">
                                        <span className="input__label-content">{this.translate('email')}</span>
                                    </label>
                                </div>

                                <div className="submitcircle">
                                    <input className="button_bold" type="submit" value={this.translate('forgotPassword')}/>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
                {/*<!-- / Pwd request -->*/}

                <div>
                    {/*<!-- BG Teaser + Verläufe -->*/}
                    <div id="MyTeaser" style={{display: 'block'}}>&nbsp;</div>
                    <div id="gradients" style={{display: 'block'}}>&nbsp;</div>
                    {/*<!-- / BG Teaser + Verläufe -->*/}

                    <header style={{display: 'block'}}>My.ZSK</header>

                    <div className="formdata width">
                        {/*<form action="javascript:void(0);" onsubmit="return myLogin.auth();">*/}
                        <div>
                            <h1>{this.translate('login')}</h1>

                            <table style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td className="text-left">{this.translate('loginEmail')}</td>

                                        <td className="text-left">
                                            <input
                                                id="loginEMail"
                                                className="input__field"
                                                type="text"
                                                value={this.state.inputParams.loginEMail}
                                                autoFocus={(this.state.inputParams.focus === 'loginEMail')}
                                                onKeyDown={this.focusPassword}
                                                onChange={this.handleEMail}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('password')}</td>

                                        <td className="text-left">
                                            <input
                                                id="loginPassword"
                                                className="input__field"
                                                type="password"
                                                value={this.state.inputParams.loginPassword}
                                                autoFocus={(this.state.inputParams.focus === 'loginPassword')}
                                                onKeyDown={this.handleKeyPress}
                                                onChange={this.handlePassword}
                                                ref={(input) => this.passwordInput = input}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('language')}</td>

                                        <td className="text-left selbox">
                                            <div className="lang-select">
                                                <div id="ddArr" className="arrow">&nbsp;</div>

                                                <select id="langselector" value={this.selectedLanguage} onChange={(event) => this.changeLanguage(event)}>
                                                    {options}
                                                </select>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">&nbsp;</td>

                                        <td className="text-left selbox">
                                            <div className="clearfix">
                                                <div className="submitmsgcontainer">
                                                    <div className="error">
                                                        <p className="fail">Login fehlgeschlagen</p>
                                                        {/*<!-- <p className="lock">Login gesperrt (3 Min.)</p> -->*/}
                                                    </div>

                                                    <div className="clearfix">
                                                        <div className="buttonFrame flr">
                                                            <input type="submit" value={this.translate('submit')} onClick={() => this.handleRequest()}/>
                                                        </div>

                                                        <div className="buttonFrame fll">
                                                            <input type="button" value={this.translate('forgotPassword')} onClick={() => this.handleForgotPassword()}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/*<!-- /Submit + Messages -->*/}
                        {/*<!-- Service-Links -->*/}
                        {/*<div className="clearfix"></div>*/}
                        {/*<a className="linkunit passwordrequest" href="test.html">*/}
                        {/*<p>{this.translate('forgotPassword')}</p></a>*/}
                        {/*<hr className="service"/>*/}

                        {/*<div className="clearfix"></div>*/}
                        {/*<a className="linkunit" href="test.html">*/}
                        {/*<p>{this.translate('register')}</p></a>*/}
                        {/*<hr className="service"/>*/}
                        {/*<!-- / Service-Links -->*/}

                        {/*<!-- Service-Links -->*/}
                        <div>
                            <div className="clearfix" style={{marginTop: 20}}>
                                <div className="buttonFrame width33 fll" style={{borderRight: '2px solid #fff', paddingRight: 10}}>
                                    <div className="frameBlock">
                                        <h4>{this.translate('forNewCustomers')}</h4>
                                    </div>

                                    <div className="frameBlock">{this.translate('needNewMyAccount')}</div>

                                    <div className="frameBlock">
                                        <input type="button" value={this.translate('register')} onClick={() => this.handleRegister()}/>
                                    </div>
                                </div>

                                <div className="buttonFrame width66 fll" style={{paddingLeft: 10}}>
                                    <div className="frameBlock">
                                        <div className="frameBlock">
                                            <h4>{this.translate('forNewAndExistingCustomers')}</h4>
                                        </div>

                                        <div className="clearfix">
                                            <div className="width50 fll">
                                                <div className="frameBlock" style={{marginTop: 0}}>{this.translate('downloadDcSoftware')}</div>

                                                <div className="frameBlock">
                                                    <a className="button" href={linkToDownload} target="_blank">{this.translate('download')}</a>
                                                </div>
                                            </div>

                                            <div className="width50 flr">
                                                <div className="frameBlock" style={{marginTop: 0}}>{this.translate('buyNewLicenceOrExistingOne')}</div>

                                                <div className="frameBlock">
                                                    <a className="button" href="https://shop.zsk.de" target="_blank">{this.translate('myzskShop')}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<!-- / Service-Links -->*/}

                        <div className="noteBox" style={{textAlign: 'center'}}>{this.translate('browserNote')}</div>

						<div className="attentionBox">
							<span className="attentionSign">{this.translate('attention')}:</span>
							<span>{this.translate('attentionDataWillBeDeleted')}</span>
						</div>
                    </div>

                    <footer style={{display: 'block'}}>
                        <div className="rt">
                            <p>
                                <a href={zskHomePage} target="_blank" rel="noopener noreferrer">www.zsk.de</a>
                                |
                                <a href={zskConditionLink} target="_blank" rel="noopener noreferrer">{this.translate('termsAndConditions')}</a>
                                |
                                <a href={zskPolicyLink} target="_blank" rel="noopener noreferrer">{this.translate('privacyPolicy')}</a>
                                |
                                <a href={zskImprintLink} target="_blank" rel="noopener noreferrer">{this.translate('imprint')}</a>
                            </p>
                        </div>

                        <div className="lb">
                            <p>
                                <a href={zskContactLink} target="_blank" rel="noopener noreferrer" className="contactIcon">{this.translate('contact')}</a>
                            </p>
                        </div>

                        <div className="mig">Made in Germany</div>
                    </footer>
                </div>

                <style dangerouslySetInnerHTML={{__html: `#atlwdg-trigger {display : none;}`}}/>
            </div>
        );

    }

}

export default LoginPage;